import { Icon, styled } from '@innowise-group/mui-kit';

export const Modal = styled.div<{ insideModal?: boolean }>`
  background-color: ${({ theme }) => theme.palette.general.paper};
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: ${({ insideModal }) => (insideModal ? '85vh' : '90vh')};
  width: ${({ insideModal }) => (insideModal ? '75vw' : '85vw')};
  max-width: 1320px;
  min-width: 510px;
  margin: 20px 90px;
  position: relative;
  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 90vh;
    width: 85vw;
    min-width: 0;
  }
`;

export const PDFViewerContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;

  & #proxy-renderer {
    min-height: 0;
    overflow-y: auto;
  }

  & #pdf-download {
    display: none;
  }
`;

export const CustomIcon = styled(Icon)`
  cursor: pointer;
`;

export const ModalActions = styled.div`
  position: absolute;
  top: 0;
  right: -60px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const ActionItem = styled.a`
  display: block;
  cursor: pointer;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.general.paper};
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  & * {
    margin: 0;
    padding: 0;
  }

  & svg {
    fill: ${({ theme }) => theme.palette.state.error.pressed};
  }
  &:hover svg {
    fill: ${({ theme }) => theme.palette.state.error.default};
  }
`;
